import { AuthErrorCodes } from 'firebase/auth';

export const authError = (errorCode: string) => {
  switch (errorCode) {
    case AuthErrorCodes.INVALID_PASSWORD:
      return 'invalid password';
    case AuthErrorCodes.INVALID_EMAIL:
      return 'invalid email';
    case AuthErrorCodes.CREDENTIAL_ALREADY_IN_USE:
      return 'credentials already in use';
    case AuthErrorCodes.EMAIL_EXISTS:
      return 'An account with this email address already exists';
    case AuthErrorCodes.USER_DELETED:
      return 'No account found with this email address';
    case AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER:
      return 'Too many requests. Please try again later';
    default:
      return errorCode;
  }
};
